import React, { useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { withStyles } from 'tss-react/mui';
import ReactEcharts from 'echarts-for-react';
import { dayjs } from '@lba-dev/package.local-globals/dayjs';

import api from '../../api';
import notifSystem from '../../notifSystem';
import { getIQGChartOptions } from '../IQG';
import StatsPanel from '../Stats/common/panel/StatsPanel';

const styles = {
  root: {
    padding: 16,
  },
  chart: {
    height: 380,
  },
  emptyMessage: {
    textAlign: 'center',
  },
};

const mapStateToProps = ({ dialog: { contentProps } }) => ({
  artisanId: contentProps.artisanId,
});

const IQGHistoryDialog = ({ artisanId, classes }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [from, setFrom] = useState(dayjs().startOf('year').toDate());
  const [to, setTo] = useState(dayjs().endOf('year').toDate());

  const fetchData = useCallback(() => {
    if (!artisanId) {
      return;
    }
    setLoading(true);
    api.stats
      .custom(`partenariat/artisan/${artisanId}/iqg/historique`)
      .get({
        from: from.toISOString(),
        to: to.toISOString(),
      })
      .then((res) => {
        setData(res.body().map((e) => e.data()));
      })
      .catch(() => {
        notifSystem.error(
          'Erreur',
          'Impossible de charger l\'historique IQG'
        );
      })
      .finally(() => setLoading(false));
  }, [artisanId, from, to]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleDatesChange = (newFrom, newTo) => {
    setFrom(newFrom);
    setTo(newTo);
  };

  return (
    <StatsPanel
      title={`Historique IQG ${dayjs(from).format('YYYY')}`}
      onDatesChange={handleDatesChange}
      enabledModes={[false, false, false, true, false]}
      defaultState={{
        mode: 'year',
        from,
        to,
      }}
      displayModePanel={true}
      displayDatesDropper={true}
    >
      {loading && (
        <Box display="flex" justifyContent="center" p={4}>
          <CircularProgress />
        </Box>
      )}
      {!loading && data.length === 0 && (
        <Box p={2} className={classes.emptyMessage}>
          <Typography variant="body1" color="textSecondary">
            Aucune donnée disponible pour cette période
          </Typography>
        </Box>
      )}
      {!loading && data.length > 0 && (
        <ReactEcharts
          notMerge
          option={getIQGChartOptions(data)}
          className={classes.chart}
        />
      )}
    </StatsPanel>
  );
};

export default connect(mapStateToProps)(
  withStyles(IQGHistoryDialog, styles)
);
